import { ApiCall } from '../helper/axios';
const BASE = '/api/ad-testing';
const adTestingService = {
    getFunnelSpend(params, token) {
        return ApiCall('GET', `${BASE}/funnel-spend`, params, { Authorization: token || '' });
    },
    getMonthlyBudget(params, token) {
        return ApiCall('GET', `${BASE}/monthly-budget`, params, { Authorization: token || '' });
    },
    saveMonthlyBudget(payload, token) {
        return ApiCall('PUT', `${BASE}/monthly-budget`, payload, { Authorization: token || '' });
    },
    getBenchmarkHistory(params, token) {
        return ApiCall('GET', `${BASE}/benchmark-history`, params, { Authorization: token || '' });
    },
    getAdDayByDay(params, token) {
        return ApiCall('GET', `${BASE}/ad-day-by-day`, params, { Authorization: token || '' });
    },
    refreshBenchmark(payload, token) {
        return ApiCall('POST', `${BASE}/refresh-benchmark`, payload, { Authorization: token || '' });
    },
    // Refresh-data icon → kicks off the background Meta sync + test rebuild (fire-and-forget).
    refreshData(payload, token) {
        return ApiCall('POST', `${BASE}/refresh-data`, payload, { Authorization: token || '' });
    },
    // Poll target — is the on-demand refresh still running for this client?
    getRefreshStatus(params, token) {
        return ApiCall('GET', `${BASE}/refresh-status`, params, { Authorization: token || '' });
    },
    getTests(params, token) {
        return ApiCall('GET', `${BASE}/tests`, params, { Authorization: token || '' });
    },
    // Past History filter prefs (startDate / endDate / funnel / results), cached per user (Redis).
    getPastFilters(token) {
        return ApiCall('GET', `${BASE}/past-filters`, undefined, { Authorization: token || '' });
    },
    savePastFilters(payload, token) {
        return ApiCall('PUT', `${BASE}/past-filters`, payload, { Authorization: token || '' });
    },
    // Client selection (client + group store), cached per user (Redis) — persists across refresh.
    getSelection(token) {
        return ApiCall('GET', `${BASE}/selection`, undefined, { Authorization: token || '' });
    },
    saveSelection(payload, token) {
        return ApiCall('PUT', `${BASE}/selection`, payload, { Authorization: token || '' });
    },
    getAdPreview(params, token) {
        return ApiCall('GET', `${BASE}/ad-preview`, params, { Authorization: token || '' });
    },
    getAdAudience(params, token) {
        return ApiCall('GET', `${BASE}/ad-audience`, params, { Authorization: token || '' });
    },
    // Grouped Evaluation popup — merge same-POST-ID evergreen/promo ads, evaluate vs TOF/MOF/BOF.
    getAdGroups(params, token) {
        return ApiCall('GET', `${BASE}/ad-groups`, params, { Authorization: token || '' });
    },
    lockTest(payload, token) {
        return ApiCall('PUT', `${BASE}/tests/${payload.id}/lock`, { lock: payload.lock, amount: payload.amount ?? undefined }, { Authorization: token || '' });
    },
};
export default adTestingService;
